import {useState, useRef} from "react";
import {Link} from 'react-router';
import {Button, Card, DatePicker, Row, Col, Table} from "antd";
import {getCashFlowReport} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";
import {toFSDateTime} from "../../util/timeutils";
import {BankTransactionType} from "../../api/Constants";
import {getBaseColumnSearchProps, getColumnSearchProps} from "../widget/SearchProps";
import {saveAs} from 'file-saver';
import {toFSDate} from "../../util/timeutils";

export const CashFlowReport = ({refresh, onRefresh, onApiFail}) => {
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);

    const [lineItems, setLineItems] = useState([]);
    // const [report, setReport] = useState({});
    const [disable, setDisable] = useState(false);
    const [numReports, setNumReports] = useState(0);

    const onStartDateChange = (date, dateString) => {
        setStartDate(dateString);
    }

    const onEndDateChange = (date, dateString) => {
        setEndDate(dateString);
    }

    const runReport = () => {
        setDisable(true);
        getCashFlowReport(startDate, endDate).then(result => {
            const lines = result.map(r => {
                return {
                    ...r,
                    key: r.id
                }
            }).sort((a, b) => {
                const aDate = new Date(a.date);
                const bDate = new Date(b.date);
                return aDate - bDate;
            }) ;

            setLineItems(lines);

            setNumReports(numReports + 1);
        }).catch(e => {
            handleNoSession(e, onApiFail);
        }).finally(() => {
            setDisable(false);
        })
    }

    const handleDownload = () => {
        const lineData = [];
        lineItems.forEach(l => {
            // date, amount, account, username, type, notes
            const lineBuffer = `${toFSDate(new Date(l.date))}, $ ${l.amount}, ${l.accountName}, ${l.username}, ${BankTransactionType.Label[l.type]}, ${l.notes}\n`;
            lineData.push(lineBuffer);
        })
        const file = new Blob(lineData, { type: 'text/plain;charset=utf-8' });

        const filename = `cashflow_${toFSDate(new Date(startDate))}_${toFSDate(new Date(endDate))}.csv`
        saveAs(file, filename);
    };

    const searchInput = useRef(null);
    const transactionColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (val) => toFSDateTime(new Date(val)),
            sorter: (a, b) => (new Date(a.date))- (new Date(b.date)),
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record) => {
                const {id} = record;
                return <Link to={`/transaction/${id}`}>$ {val}</Link>
            },
            sorter: (a, b) => {
                return parseFloat(a.amount) - parseFloat(b.amount);
            }
        },
        {
            title: 'Account',
            dataIndex: 'accountName',
            key: 'accountName',
            render: (val, record) => {
                return <Link to={`/bank/${record.accountId}`}>{val}</Link>
            },
            ...getColumnSearchProps("accountName", searchInput, false)
        },
        {
            title: 'Confirmed By',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (val, record, index) => {
                return BankTransactionType.Label[val]
            },
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (val, record, index) => {
                if (record.notes) {
                    if (record.invoiceId) {
                        return <Link to={`/invoice/${record.invoiceId}`}>{val}</Link>
                    } else {
                        return record.notes;
                    }
                } else {
                    return <div style={{color: "red"}}>N/A</div>
                }
            },
            ...getBaseColumnSearchProps("invoiceNumber", searchInput),
            onFilter: (value, record) => {
                const {invoiceNumber} = record;
                let columnValue = "";
                if (invoiceNumber) {
                    columnValue = invoiceNumber;
                } else if (record.notes) {
                    columnValue = record.notes;
                }
                return columnValue.toString().toLowerCase().includes(value.toLowerCase())
            },
        },
    ];

    const cardStyle= {
        textAlign: 'left',
        margin: '5px'
    }

    const rowStyle = {
        margin: '10px'
    }

    return <div>
        <Card style={{textAlign: 'left', margin: "5px"}} title={"Run Cash Flow Report"}>
            <Row style={rowStyle}>
                <Col style={{marginTop: '5px', width: '80px'}}><b>Start Date: </b></Col>
                <Col><DatePicker onChange={onStartDateChange} /></Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={{marginTop: '5px', width: '80px'}}><b>End Date: </b></Col>
                <Col><DatePicker onChange={onEndDateChange} /></Col>
            </Row>
            <Button onClick={runReport} disabled={disable}>Run</Button>
        </Card>

        <Card style={cardStyle} title={<b>Summary View</b>}>
            <Row style={rowStyle}>
                <Button disabled={lineItems.length <= 0} onClick={handleDownload}>Save CSV</Button>
            </Row>
            <Table columns={transactionColumns} dataSource={lineItems} pagination={false} />
        </Card>

    </div>
}